import { GymMemberData } from '../types/types'

/**
 * Last workout tracked at this gym (acl.lastActivityRecord), ms.
 * 0 if the member never tracked here
 */
export const trackedAtMs = (member: GymMemberData) =>
  member.lastActivityRecord
    ? member.lastActivityRecord.createdDate.seconds * 1000
    : 0

/**
 * When the member joined this gym, ms. 0 if unknown.
 * usePeopleManagement converts joinDate to ms; older docs may be Timestamps
 */
export const joinedAtMs = (member: GymMemberData) =>
  typeof member.joinDate === 'number'
    ? member.joinDate
    : (member.joinDate?.seconds ?? 0) * 1000
